module.exports = __webpack_public_path__ + "img/icon-settings.3b220520.svg";